import { httpTypes } from '@/utility/types';
import http from './http';

export default {
  async [httpTypes.GET_DATA]({ route, config }) {
    const response = await http.get(`${route}`, config);
    return response.data;
  },
};
